import { Typography, Paper, Grid,} from '@material-ui/core';
import { makeStyles } from "@material-ui/styles";
import React, {useState, useEffect} from 'react';
import {XAxis, YAxis, Label, PieChart, Pie, Cell} from 'recharts';
import {LineChart, Line, CartesianGrid, ResponsiveContainer, Tooltip} from "recharts";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#ced8d7",
    paddingBottom: "8px"
  },
  lineGraphTitle1: {
    paddingTop: "0px",
    marginTop: "8px",
  },
  lineGraphTitle: {
    paddingTop: "0px",
    marginTop: "0px",
  },
  graphTitle: {
    paddingTop: "8px",
    marginBottom: "0px",
  },
  pieTitle: {
    paddingTop: "15px",
    marginTop: "8px",
    marginBottom: "-22px",
    textAlign: "center"
  },
  pieLabel: {
    paddingTop: "0px",
    marginTop: "-15px",
    marginBottom: "2px",
    textAlign: "center"
  },

}));

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const Map3Plots = (props) => {
const classes = useStyles();
let graphData = props.graphData;
const [newGraphData, setNewGraphData] = useState([]);
const [pieData, setPieData] = useState([]);

useEffect (() => {
  if (graphData !== null) {
    setNewGraphData([
      {
        date: 2016,
        canopy: graphData.canopyCoverMean16,
        biomass: graphData.biomassSum16,
        basal: graphData.basalMean16
      },
      {
        date: 2017,
        canopy: graphData.canopyCoverMean17,
        biomass: graphData.biomassSum17,
        basal: graphData.basalMean17
      },
      {
        date: 2018,
        canopy: graphData.canopyCoverMean18,
        biomass: graphData.biomassSum18,
        basal: graphData.basalMean18
      },
      {
        date: 2019,
        canopy: graphData.canopyCoverMean19,
        biomass: graphData.biomassSum19,
        basal: graphData.basalMean19
      },
      {
        date: 2020,
        canopy: graphData.canopyCoverMean20,
        biomass: graphData.biomassSum20,
        basal: graphData.basalMean20
      },
    ]);
    }
}, [graphData])

useEffect (() => {
  if (graphData !== null) {
    let intRemaining = Math.round((parseFloat(graphData.biomassSum20)/parseFloat(graphData.biomassSum16))*100)
    let intLost = Math.round((parseFloat(graphData.biomassSum16 - graphData.biomassSum20))/(parseFloat(graphData.biomassSum16))*100)
    if (intLost > 0) {
    setPieData ([
      { name: "Biomass Lost (%)", value: (Math.round((parseFloat(graphData.biomassSum16 - graphData.biomassSum20))/(parseFloat(graphData.biomassSum16))*100)) },
      { name: "Remaining Biomass (%)", value: Math.round((parseFloat(graphData.biomassSum20)/parseFloat(graphData.biomassSum16))*100) },
    ])
    } else {
      setPieData([
        { name: "Biomass Lost (%)", value: 0 },
        { name: "Remaining Biomass (%)", value: Math.round((parseFloat(graphData.biomassSum20)/parseFloat(graphData.biomassSum16))*100) },
      ])
    }
    }
}, [graphData])

    return (
      <div className={classes.root}>
        <Grid container spacing={0} >
          <Grid item xs={12}>
            <Paper elevation={3} style={{ marginTop: "6px", paddingBottom: "8px" }} >
              {/* <Tooltip title={<><Typography>Select a red Fire Zone on the map to see the statistics</Typography></>}> */}
                <Typography
                    className={classes.graphTitle}
                    align="center"
                    variant="subtitle1"
                  >
                    <b>Change Over Time in Selected Fire Boundaries</b>
                  </Typography>
              {/* </Tooltip> */}
              <Typography
                className={classes.lineGraphTitle1}
                align="center"
                variant="subtitle1"
              >
                Canopy Cover
              </Typography>
              <div className="area-chart-wrapper">
              <ResponsiveContainer width="100%" height={160}>
                  <LineChart
                      // width={500}
                      height={180}
                      data={newGraphData}
                      syncId="anyId"
                      margin={{
                        top: 5,
                        right: 30,
                        left: 5,
                        bottom: 0,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date">
                        <Label value="Percent (%)" angle={-90} offset={-45} position="insideTopLeft" />
                      </XAxis>
                      <YAxis/>
                      <Tooltip />
                      <Line type="monotone" dataKey="canopy" stroke="#8884d8" fill="#8884d8" />
                    </LineChart>
                  </ResponsiveContainer>
                  <Typography
                    className={classes.lineGraphTitle}
                    align="center"
                    variant="subtitle1"
                  >
                    Biomass
                  </Typography>
                  <ResponsiveContainer width="100%" height={160}>
                    <LineChart
                      // width={500}
                      height={180}
                      data={newGraphData}
                      syncId="anyId"
                      margin={{
                        top: 5,
                        right: 30,
                        left: 0,
                        bottom: 0,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" >
                        <Label value="Mg/ha" angle={-90} offset={-45} position="insideTopLeft" />
                      </XAxis>
                      <YAxis />
                      <Tooltip />
                      <Line type="monotone" dataKey="biomass" stroke="#82ca9d" fill="#82ca9d" />
                    </LineChart>
                  </ResponsiveContainer>
                  <Typography
                    className={classes.lineGraphTitle}
                    align="center"
                    variant="subtitle1"
                  >
                    Basal Area
                  </Typography>

                  <ResponsiveContainer width="100%" height={160}>
                    <LineChart
                      // width={500}
                      height={180}
                      data={newGraphData}
                      syncId="anyId"
                      margin={{
                        top: 5,
                        right: 30,
                        left: 0,
                        bottom: 0,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" >
                        <Label value="ft²/acre" angle={-90} offset={-45} position="insideTopLeft" />
                      </XAxis>
                      <YAxis />
                      <Tooltip />
                      <Line type="monotone" dataKey="basal" stroke="#bfd746" fill="#bfd746" />
                      </LineChart>
                  </ResponsiveContainer>
              </div>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper elevation={3}>
              <Typography
                className={classes.pieTitle}
                align="left"
                variant="subtitle1"
              >
                Change in Forested Biomass
              </Typography>
                  <PieChart width={270} height={220}>
                  <Pie
                    //   isAnimationActive={false}
                    data={pieData}
                    cx="50%"
                    cy="50%"
                    outerRadius={80}
                    label={renderCustomizedLabel}
                    labelLine={false}
                    legendType="circle"
                  >
                    <Cell key={"Remaining Biomass (%)"} fill={"#000000"} />
                    <Cell key={"Biomass Lost (%)"} fill={"#597d35"} />
                  </Pie>
                <Tooltip />
              </PieChart>
              <Typography
                className={classes.pieLabel}
                align="left"
                variant="subtitle2"
              >
                *Only comparing 2016 and 2020 data
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} direction="column" alignItems="center">
            <Paper
              elevation={3}
              align="center"
              style={{
                padding: "15px",
                marginTop: "10px",
                marginBottom: "10px",
                marginLeft: "10px",
                width: "260px",
              }}
            >
              <Typography variant="subtitle2">Total Change in Canopy Cover</Typography>
              {graphData !== null && (
              <Typography variant="subtitle1">{(parseInt(graphData.canopyCoverMean18) - parseInt(graphData.canopyCoverMean16))} %</Typography>
              )}
            </Paper>

            <Paper
              elevation={3}
              align="center"
              style={{ padding: "15px", marginLeft: "10px", width: "260px", marginBottom: "10px",
            }}
            >
              <Typography variant="subtitle2">Total Change in Biomass</Typography>
              {graphData !== null && (
              <Typography variant="subtitle1">{(parseInt(graphData.biomassSum18) - parseInt(graphData.biomassSum16))} Mg/ha</Typography>
              )}
            </Paper>

            <Paper
              elevation={3}
              align="center"
              style={{ padding: "15px", marginLeft: "10px", width: "260px" }}
            >
              <Typography variant="subtitle2">Total Change in Basal Area</Typography>
              {graphData !== null && (
              <Typography variant="subtitle1">{(parseInt(graphData.basalMean18) - parseInt(graphData.basalMean16))} ft²/acre</Typography>
              )}
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
}

export default Map3Plots
